import { useAuth } from "@/store/auth";
import { refreshSeeriApiConfig } from "./seeri-api";

export const initializeDependencies = async () => {
  await refreshSeeriApiConfig();
  await useAuth.getState().refreshUserData();
};
